export default "__VITE_ASSET__Dsr9e$fT__"